import { createSelector } from '@reduxjs/toolkit';
import {
    selectLoggedIn,
    DecodedSsoToken,
    DecodedCloudToken,
    selectDecodedToken,
    selectDecodedSsoToken,
} from '@ovpn-ui-toolkit/mf-common';

export * from './role.selectors';

export const selectIsAWSCustomer = createSelector(
    selectDecodedSsoToken,
    // TODO: fix SsoToken type in toolkit
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    jwt => jwt?.awsmp === 'true',
);

export const selectSsoPercentile = createSelector(
    selectDecodedSsoToken,
    (jwt: DecodedSsoToken | null) => Number(jwt?.perc ?? '0'),
);

export const selectSsoJTI = createSelector(selectDecodedSsoToken, jwt => jwt?.jti ?? '');

export const selectIdpUserId = createSelector(selectDecodedSsoToken, jwt => jwt?.idp_user_id ?? '');

export function isTokenJtiValid(
    ssoToken: DecodedSsoToken | null,
    cvpnToken: DecodedCloudToken | null,
): boolean {
    return !!ssoToken && !!cvpnToken && ssoToken.jti === cvpnToken.master_jti;
}

export const selectIsLoggedIn = createSelector(
    selectDecodedSsoToken,
    selectDecodedToken,
    selectLoggedIn,
    (ssoToken, cvpnToken, loggedIn) => isTokenJtiValid(ssoToken, cvpnToken) && loggedIn,
);
